export const IssueTypeEnum = {
  AUDIT_FINDING: 'audit-finding',
  CONTROL_DEFICIENCY: 'control-deficiency',
  ISSUE: 'issue',
  INCIDENT: 'incident',
  EXCEPTION: 'exception',
} as const;
export const StandardIssueTypeValues = [
  IssueTypeEnum.ISSUE,
  IssueTypeEnum.INCIDENT,
  IssueTypeEnum.EXCEPTION,
] as const;

export const IssueTypeDisplayEnum = {
  AUDIT_FINDING: 'Audit finding',
  CONTROL_DEFICIENCY: 'Control deficiency',
  ISSUE: 'Issue',
  INCIDENT: 'Incident',
  EXCEPTION: 'Exception',
} as const;

export const SourceAppEnum = {
  RISK_MANAGER: 'risk-manager',
  AUDIT: 'audit',
  INTERNAL_CONTROLS: 'internal-controls',
  ISSUE_MANAGEMENT: 'issue-management',
  ASSET_MANAGER: 'asset-manager',
} as const;

export const SourceEntityTypeEnum = {
  RISK: 'risk',
  AUDIT: 'audit',
  CONTROL: 'control',
  PROCESS: 'process',
  OBJECTIVE: 'objective',
  CONTROL_ASSESSMENT: 'control-assessment',
  RISK_MITIGATION: 'risk-mitigation',
  RISK_ASSESSMENT: 'risk-assessment',
  ASSET: 'asset',
  ASSET_FINDING: 'asset-finding',
} as const;

export const SOURCE_URL_PARAMS_KEYS = [
  'sourceApp',
  'type',
  'sourceEntityId',
  'sourceEntityName',
  'sourceEntityLink',
  'callbackUrl',
  'sourceEntityType',
] as const;

export const IssueTypeValues = Object.values(IssueTypeEnum) as [
  (typeof IssueTypeEnum)[keyof typeof IssueTypeEnum],
];
export const IssueTypeDisplayValues = Object.values(IssueTypeDisplayEnum) as [
  (typeof IssueTypeDisplayEnum)[keyof typeof IssueTypeDisplayEnum],
];
export const SourceAppValues = Object.values(SourceAppEnum) as [
  (typeof SourceAppEnum)[keyof typeof SourceAppEnum],
];
export const SourceEntityTypeValues = Object.values(SourceEntityTypeEnum) as [
  (typeof SourceEntityTypeEnum)[keyof typeof SourceEntityTypeEnum],
];

export type IssueType = (typeof IssueTypeValues)[number];
export type StandardIssueType = (typeof StandardIssueTypeValues)[number];
export type SourceAppType = (typeof SourceAppValues)[number];
export type SourceEntityType = (typeof SourceEntityTypeValues)[number];
export type SourceUrlParamsKeys = (typeof SOURCE_URL_PARAMS_KEYS)[number];
